<template>
  <div>
    <recapitulatif-montant
      :recapitulatif-montant="recapitulatifMontant"
      v-if="recapitulatifMontant"
    ></recapitulatif-montant>
    <store-recherche-provider
      name="PlanMVentes"
      :copy="storeCommande"
      :copyChanges="changesCommandeStore">
        <tab-liste-lignes-commande
          :nameStore="storeNameFromProvider"
        />
    </store-recherche-provider>
  </div>
</template>

<script>
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import tabListeLignesCommande from '@/components/bodac/lignesCommande/tabListeLignesCommande';
import recapitulatifMontant from '@/components/planMedia/recapitulatifMontant';
import storeCommande, { initialState } from '@/store/modules/bodac/commandeParLigneCommande';
import { STORE_NAME_PLAN_MEDIA_VENTE } from '@/configuration/commande/commandeConf';
import * as allTypes from '@/store/mutation-type';

export default {
  name: 'infoVentes',
  data() {
    return {
      constantes: {
        STORE_NAME_PLAN_MEDIA_VENTE,
      },
      storeCommande,
      changesCommandeStore: {
        state: initialState(STORE_NAME_PLAN_MEDIA_VENTE, false),
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initialState(STORE_NAME_PLAN_MEDIA_VENTE, false);
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      },
    };
  },
  props: {
    recapitulatifMontant: {
      type: Object,
      required: false,
    },
  },
  components: {
    tabListeLignesCommande,
    recapitulatifMontant,
    storeRechercheProvider,
  },
  computed: {
    storeNameFromProvider() {
      return STORE_NAME_PLAN_MEDIA_VENTE;
    },
  },
};
</script>
